import { inventories } from "@/api/inventories/useInventoriesQuery";
import useFetcher from "@/hooks/useFetcher";
import { ProductionPlansGet200ResponseRowsInnerWorksInner } from "@sizlcorp/sizl-api-document/dist/models";

interface useInventoriesFetchProps {
  workData: ProductionPlansGet200ResponseRowsInnerWorksInner;
}

export const useInventoriesFetch = ({ workData }: useInventoriesFetchProps) => {
  const { queryKey, queryFn } = inventories.find({
    query: {
      $and: [
        {
          itemCode: workData?.routingData?.routingBoms?.map(
            (bom) => bom.itemCode
          ),
        },
        {
          locationCode: workData?.locationSetting?.toLocation?.code,
        },
        { quantity: { $ne: 0 } },
      ],
    },
    populate: ["item", "lot"],
    sort: "createdAt",
  });

  const { data, Fetcher } = useFetcher(
    {
      queryKey: queryKey,
      queryFn: queryFn,
    },
    { enabled: !!workData }
  );

  return { data, Fetcher };
};
